export const PROFILE_CHANGE_KEY = 'PROFILE_CHANGE_KEY';

export const profileChangeKeys = payload => ({
  type: PROFILE_CHANGE_KEY,
  payload,
});
